import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

import { Download, Layers, Presentation, Users } from "@/components/icons"
import { useUsageSummary } from "@/features/slide-sense/hooks/use-slide-sense-usage"

import { DashboardSectionCard, KPI } from "./admin-dashboard-shared"

export function SlideSenseUsageSection() {
  const { t } = useTranslation()
  const { data, isLoading } = useUsageSummary("30d")

  return (
    <DashboardSectionCard
      description={t("adminDashboard.slideSenseUsage.description")}
      icon={Presentation}
      id="slide-sense-usage"
      title={t("adminDashboard.sections.slideSenseUsage")}
      actions={
        <Link className="text-primary text-sm" to="/slide-sense">
          {t("adminDashboard.viewDetails")}
        </Link>
      }
    >
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <KPI
          icon={Users}
          isLoading={isLoading}
          label={t("slideSense.usage.kpi.activeUsers")}
          value={data?.kpi.active_users != null ? String(data.kpi.active_users) : "—"}
        />
        <KPI
          icon={Download}
          isLoading={isLoading}
          label={t("slideSense.usage.kpi.totalExports")}
          value={data?.kpi.total_exports != null ? String(data.kpi.total_exports) : "—"}
        />
        <KPI
          icon={Presentation}
          isLoading={isLoading}
          label={t("slideSense.usage.kpi.totalPresentations")}
          value={data?.kpi.total_presentations != null ? String(data.kpi.total_presentations) : "—"}
        />
        <KPI
          icon={Layers}
          isLoading={isLoading}
          label={t("slideSense.usage.kpi.distinctSlidesUsed")}
          value={
            data?.kpi.distinct_slides_used != null ? String(data.kpi.distinct_slides_used) : "—"
          }
        />
      </div>
    </DashboardSectionCard>
  )
}
